var map = {
	"./bcx/bot.png": 58108,
	"./blueoak/bot.png": 72382,
	"./default/bot.png": 99862,
	"./eskom/bot.png": 55574,
	"./momentum/bot.png": 20332,
	"./tigerbrands/bot.png": 58987,
	"./tongaat/bot.png": 58372,
	"./xib-demo/bot.png": 77991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54239;